"use client"

import * as amplitude from "@amplitude/analytics-browser"
import { getServerOrClientCookies } from "./cookies"

const isProd =
  process.env.NEXT_PUBLIC_VERCEL_ENV === "production" ||
  process.env.NEXT_PUBLIC_FORCE_PROD

const AMPLITUDE_KEY = isProd
  ? "5b9bf00b987cbea59d468256dfa811bc"
  : "d7c23b6953102806c5d5331dcd65bdcc"

const isBrowser = typeof window !== "undefined"

const serverUrl = isProd
  ? "https://api.paragraph.com/amp2"
  : "http://localhost:8080/amp2"

export async function initializeAmplitude() {
  if (!isBrowser || !isProd) return null

  const userId = await getServerOrClientCookies("userId")

  console.log("Initializing Amplitude")
  amplitude.init(AMPLITUDE_KEY, userId, {
    serverUrl,
    autocapture: {
      elementInteractions: true,
      fileDownloads: true,
      formInteractions: true,
      sessions: true,
      pageViews: true,
      attribution: true,
    },
  })
}
